import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import letterFadeScaleStartInGif from '../../../assets/images/transitions/letterFadeScaleStartIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_LETTER_FADE_SCALE_START_OUT = 'letterFadeScaleStartOut';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const letterFadeScaleStartOutPresetDetails = {
  // The name of the preset.
  name: PRESET_LETTER_FADE_SCALE_START_OUT,

  // A human friendly name for the preset.
  humanName: 'Letter - (Fade & Scale & Track) Out From Start',

  // A preview of the transition.
  gif: letterFadeScaleStartInGif,

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'letter.scaleX': {
      time: {
        end: 'end.0',
        start: 'end.-938'
      },
      easing: EASINGS.linear,
      values: [
        1,
        0.7
      ],
      stagger: false,
      immediateRender: false
    },
    'letter.opacity': {
      time: {
        end: 'end.-196',
        start: 'end.-938'
      },
      easing: EASINGS.linear,
      values: [
        1,
        0
      ],
      stagger: '-20',
      immediateRender: false
    },
    'transform.scaleY': {
      time: {
        end: 'end.0',
        start: 'end.-938'
      },
      easing: EASINGS.linear,
      values: [
        1,
        0.7
      ],
      immediateRender: false
    },
    'transform.perspective': {
      time: {
        end: 'end.0',
        start: 'end.-938'
      },
      easing: EASINGS.linear,
      values: [
        50,
        15
      ],
      immediateRender: false
    },
    'transform.translate3d.z': {
      time: {
        end: 'end.0',
        start: 'end.-938'
      },
      easing: EASINGS.linear,
      values: [
        0,
        9
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_LETTER_FADE_SCALE_START_OUT,
    options: {},
  },
};

letterFadeScaleStartOutPresetDetails.template.options = lodash.cloneDeep(letterFadeScaleStartOutPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_LETTER_FADE_SCALE_START_OUT;

// This defines the value of the presets object.
export default letterFadeScaleStartOutPresetDetails;
